import React from 'react';

import './ConsultantBadge.scss';

const ConsultantBadge: React.FunctionComponent<{ hasConsultantNotes?: boolean }> = (props) => {
    if (props.hasConsultantNotes === false) {
        return null;
    }

    // TODO Remove fake image
    const fakeImage = '/_Resources/Static/Packages/GesagtGetan.Products/Assets/sara.jpg';
    const fakeCount = 1;

    const counter =
        fakeCount > 0 ? <div className="consultant-badge__counter">{fakeCount > 99 ? '+' : fakeCount}</div> : '';

    return (
        <div className="small-product-teaser__badge consultant-badge">
            {counter}
            <img className="consultant-badge__image" src={fakeImage} />
            <svg className="consultant-badge__bubble icon icon--speech">
                <use xlinkHref="#icon-speech" />
            </svg>
        </div>
    );
};

export default ConsultantBadge;
